export default {
  sidebarNone: 727,
  sidebarMedium: 826,
};